<div class="card">
  <div class="card-body">
    <form [formGroup]="searchComponentsForm" class="row">
      <div class="form-group col-lg-3 col-md-4 col-xs-12">
        <label>{{resources.AllocationScaniaUnit}}:</label>
        <div class="input-group">
          <select formControlName="selectedScaniaUnit" class="form-control" required>
            <option value="" disabled="disabled"></option>
            <option value="0">*{{resources.All}}*</option>
            <option *ngFor="let scaniaUnit of scaniaUnitList | async" value={{scaniaUnit.id}}>
              {{scaniaUnit.name}} - {{scaniaUnit.description}}
            </option>
          </select>

        </div>
      </div>
      <div class="form-group col-lg-2 col-md-3 col-xs-12">
        <label>{{resources.InvoiceFrom}}:</label>
        <div class="input-group">
          <input formControlName="startDate" type="date" placeholder="yyyy-mm-dd" class="form-control" />
        </div>
      </div>
      <div class="form-group col-lg-2 col-md-3 col-xs-12">
        <label>{{resources.InvoiceTo}}:</label>
        <div class="input-group">
          <input formControlName="endDate" type="date" class="form-control" placeholder="yyyy-mm-dd" />
        </div>
      </div>
      <div class="form-group col-md-2 col-xs-12">
        <label>&nbsp;</label>
        <button class="btn btn-primary form-control" type="button" (click)="onSearch()">
          {{resources.ViewData}}
        </button>
      </div>
      <div class="form-group col-md-2 col-xs-12">
        <label>&nbsp;</label>
        <button class="btn btn-primary form-control always-hover" type="button" (click)="onExportToExcel()">
          {{resources.ExportToExcel}}
        </button>
      </div>
    </form>
  </div>
</div>

<div *ngIf="showData" class="panel" style="margin-top: 5px;">
  <div class="row" style="margin-top: 20px">
    <div class="col-sm-2">
      <div class="card" style="border: none;">
        <div class="card-body" style="padding: 0;">
          <div style="padding:5px 10px 5px 10px; font-style: italic;" class="selected">{{selectedCountValue}}
            {{resources.ItemSelected}}
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-10">
      <div class="btn-group dropleft" style="float: right; margin-bottom: 5px;">
        <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
          aria-haspopup="true" aria-expanded="false" *ngIf="showSelectActionButton()" >
          {{resources.SelectAction}}
        </button>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" (click)="validate()">
            {{resources.ManualInvoice}}
          </a>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-body">
    <cal-calsiumlist-listing [config]="listConfig" [ListBodyData]="dataList | async" (sortTriggered)="onSort($event)"
      (filterTriggered)="onFilter($event)" (clearFilterAndSortingTriggered)="onClearFilterAndSorting()"
      [isLoading]="isLoading | async" [dataTotalCount]="totalCount | async"
      [filterExpression]="filterExpression | async"
      (selectAllChanged)="onSelectAllChange($event)" (rowSelectionChanged)="onRowSelectionChange($event)">
    </cal-calsiumlist-listing>
    <cal-pagination [paging]="paging | async" (pageChange)="onPaging($event)" [dataTotalCount]="totalCount | async">
    </cal-pagination>
  </div>
</div>
